<template>
    <div id="Modal" :class="{ active: modalActive }">
        <div class="content-container">
            <div class="content">
                <div class="text">
                    <p>Our 20-Game Plans are the perfect way to enjoy the season with friends and family – or to treat
                        yourself! Choose between one of our three preset plans or get your hands on our Fan’s Choice
                        Plan, which gives you maximum flexibility by letting you choose the games you
                        want!<br /><br />Plus, as a 20-Game Plan Holder, you’ll get access to exclusive benefits
                        reserved for Lone Star
                        Members.</p>
                    <div class="button" @click="modalHide">Enter</div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Modal",
    props: ["modalActive"],
    emits: ["modalHide"],
    components: {

    },
    data() {
        return {

        };
    },
    mounted() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);

        window.addEventListener("resize", () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        });
    },
    methods: {
        modalHide() {
            this.$emit("modalHide");
        },
    },
};
</script>
<style lang="scss" scoped>
#Modal {
    background: rgba(0, 0, 0, 0.74);
    position: fixed;
    top: 0px;
    left: 0;
    width: 100vw;
    height: calc(var(--vh, 1vh) * 100);
    max-height: 0;
    opacity: 0;
    transition: all 0.5s ease-in-out;
    overflow: hidden;
    z-index: 1000;

    @media (max-width: 576px) {
        overflow-y: scroll;
        // height:100%;
    }

    &.active {
        max-height: calc(var(--vh, 1vh) * 100);
        opacity: 1;
        transition: all 0.5s ease-in-out;
    }

    .content-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        // align-items: center;
        height: 100%;
        width: 100%;
        position: relative;
    }

    .content {
        position: relative;
        width: 95%;
        max-width: 622px;
        display: block;
        padding: 80px;
        margin: auto 0;
        border-radius: 4px;
        background: var(--STH-White, #FFF);

        @media screen and (max-width: $sm) {
            padding: 40px;
        }

        .text {
            display: flex;
            flex-direction: column;
            gap: 40px;
            align-items: center;
            justify-content: center;
            width: 100%;
            max-width: 513px;
            margin: auto;
            z-index: 1;
            position: relative;

            p {
                color: var(--STH-Dark-Blue, #1E376D);
                text-align: center;
                font-family: Gotham;
                font-size: 14px;
                font-style: normal;
                font-weight: normal;
                line-height: 22px;
                margin-bottom: 0;
            }

            .button {
                border-radius: 4px;
                background: var(--STH-Dark-Blue, #1E376D);
                padding: 18px 45px;
                color: #FFF;
                text-align: center;
                font-family: Druk;
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
                letter-spacing: 0.36px;
                text-transform: uppercase;
                cursor: pointer;
            }
        }


    }
}
</style>